import React, { useEffect, useState } from 'react'
import Chart from 'react-apexcharts'
import { colors } from '../../helper/Helper'
import { Spin } from 'antd'

const LineChart = React.memo(({ graph_id = '', graph_data = [] }) => {

    const [isLoading, setIsLoading] = useState(true)

    const xAxisKey = Object.keys(graph_data[0])?.find((key) => key?.startsWith('xAxis_'))
    const xAxisData = xAxisKey ? graph_data?.map((item) => item[xAxisKey]) : []

    const chartSeries = Object?.keys(graph_data[0])
        ?.filter(key => key?.startsWith('yAxis_'))
        .map(key => ({
            name: key?.replace('yAxis_', '')?.replace(/_/g, ' '),
            data: graph_data?.map(item => item[key])
        }))

    const chartOptions = {
        chart: {
            id: graph_id || 'line_chart',
            zoom: {
                enabled: false
            },
            toolbar: {
                show: false
            }
        },
        xaxis: {
            categories: xAxisData,
            labels: {
                step: 10,
                style: {
                    colors: '#b8b8b8',
                    fontSize: '10px',
                    fontWeight: 500,
                },
            },
            tickAmount: 10,
        },
        yaxis: {
            labels: {
                formatter: function simplifyValue(value) {
                    if (value >= 10000000) {
                        return (value / 10000000) + ' Cr'
                    } else if (value >= 100000 && value < 10000000) {
                        return (value / 100000) + ' L'
                    } else if (value >= 10000 && value < 100000) {
                        return (value / 1000) + ' K'
                    } else if (value >= 1000 && value < 10000) {
                        return (value / 1000) + ' K'
                    } else {
                        return value
                    }
                },
                style: {
                    colors: '#b8b8b8',
                    fontSize: '10px',
                    fontWeight: 500,
                }
            }
        },
        tooltip: {
            theme: "dark",
            style: {
                fontSize: '12px',
            },
            y: {
                formatter: function simplifyValue(value) {
                    if (value >= 10000000) {
                        return (value / 10000000).toFixed(2) + ' Cr'
                    } else if (value >= 100000 && value < 10000000) {
                        return (value / 100000).toFixed(2) + ' L'
                    } else if (value >= 10000 && value < 100000) {
                        return (value / 1000).toFixed(2) + ' K'
                    } else if (value >= 1000 && value < 10000) {
                        return (value / 1000).toFixed(2) + ' K'
                    } else {
                        return value
                    }
                }
            }
        },
        colors: colors,
        markers: {
            size: 3,
            colors: colors,
            strokeColors: '#fff',
            strokeWidth: 0.8,
            hover: {
                size: 6
            }
        },
        grid: {
            show: false,
            borderColor: '#e5e5e5'
        },
        legend: {
            show: true,
            fontSize: '10px',
            labels: {
                useSeriesColors: true
            },

            markers: {
                size: 5,
                strokeWidth: 0,
                shape: 'circle',
            },
        },
        stroke: {
            show: true,
            curve: 'smooth',
        },
        dataLabels: {
            enabled: false
        },
    }

    useEffect(() => {
        if (chartSeries.length) {
            const timeout = setTimeout(() => setIsLoading(false), 500)
            return () => clearTimeout(timeout)
        }
    }, [chartSeries])

    return (
        <div
            style={{
                overflow: "hidden",
                width: '100%',
                height: "100%"
            }}
        >
            {isLoading ? (
                <div style={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <Spin size='large' />
                </div>
            ) : (
                <div
                    style={{
                        height: "100%",
                        width: "100%",
                        overflow: "scroll",
                        whiteSpace: "nowrap",
                    }}
                >
                    <Chart
                        options={chartOptions}
                        series={chartSeries}
                        type="line"
                        width="100%"
                        height="100%"
                    />
                </div>
            )}
        </div>
    )
})

export default LineChart